import store from "@/store";
import notificationSound from "@/assets/audio/notification.mp3";
import Vue from "vue";
import axios from "axios";
import { arrayBufferToBase64 } from "./mail";
import { getAudioDeviceManager } from "@/composables/useAudioDeviceManager";

export const INITIALIZING = "initializing";
export const INITIALIZATION_FAILED = "initialization-failed";
export const CONNECTION_FAILED = "connection-failed";
export const CONNECTING = "connecting";
export const CONNECTED = "connected";
export const DISCONNECTING = "disconnecting";
export const DISCONNECTED = "disconnected";
export const RECONNECTING = "reconnecting";

const audio = new Audio(notificationSound);

// Apply the preferred output device to the notification audio element
try {
	const audioDeviceManager = getAudioDeviceManager();

	audioDeviceManager.applyOutputDevice(audio);
} catch {
	// AudioDeviceManager may not be initialized yet at import time
}

export const playAudio = () => {
	if (store.state.conversation.audioNotificationsEnabled) {
		// Re-apply output device before each play in case user changed it
		try {
			const audioDeviceManager = getAudioDeviceManager();

			audioDeviceManager.applyOutputDevice(audio);
		} catch {
			// Ignore if manager not ready
		}
		audio.play().catch(() => {});
	}
};

export const toggleState = (state) => {
	store.commit("conversation/setConnectionState", state);
	store.commit("conversation/setIsInitializing", [INITIALIZING, CONNECTING].includes(state));
};

export const desktopNotification = () => {
	if (store.state.conversation.desktopNotificationsEnabled && document.hidden) {
		Vue.notification.show("Vous avez une nouvelle notification dans Fresk!", {
			body: "",
			silent: true
		}, {});
	}
};

export const getRecordingAsBase64 = async (recording, conversationSid, messageSid) => {
	if (!conversationSid && !messageSid) {
		return ;
	}

	const response = await axios.get(
		`voice/v1/recordings/conversations/${conversationSid}/messages/${messageSid}?url=${recording}`,
		{
			responseType: "arraybuffer"
		}
	);

	const fileInBase64 = arrayBufferToBase64(response.data);

	return fileInBase64;
};

export const getRecordingLength = async (recordingId) => {
	try {
		const { data: { duration } } = await axios.get(`voice/v1/recordings/length?recordingId=${recordingId}`);

		return duration;
	} catch (err) {
		console.error("Error fetching recording length:", err);
		return 0;
	}
};
